import { useEffect } from 'react';
import {
	COMMAND_PALETTE_ID,
	COMMAND_PALETTE_PRESSED_ANALYTICS,
} from '@atlassian/jira-command-palette-common/src/common/constants.tsx';
import { useCommandPaletteIsOpen } from '@atlassian/jira-command-palette/src/controllers/command-palette/index.tsx';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { isCommandPaletteTrigger } from './utils.tsx';

export const useRegisterDismissCommand = () => {
	const [{ isOpen }, { close }] = useCommandPaletteIsOpen();

	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		// Replace with lodash/noop
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		if (!isOpen) return () => {};

		const dismissCommandPalette = (ev: KeyboardEvent) => {
			if (!isCommandPaletteTrigger(ev)) return;

			fireUIAnalytics(createAnalyticsEvent(COMMAND_PALETTE_PRESSED_ANALYTICS), COMMAND_PALETTE_ID, {
				key: 'k',
				isDismissing: true,
			});

			ev.preventDefault();
			close();
		};

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		document.addEventListener('keydown', dismissCommandPalette);
		return () => {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			document.removeEventListener('keydown', dismissCommandPalette);
		};
	}, [close, createAnalyticsEvent, isOpen]);

	return null;
};
